import React from 'react';
import AgentSearch from './AgentSearch.js';

var AgentSearchBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$search = attrs.search,
      search = _attrs$search === void 0 ? 'zip' : _attrs$search,
      _attrs$placeholder = attrs.placeholder,
      placeholder = _attrs$placeholder === void 0 ? 'Enter Zip Code' : _attrs$placeholder;
    return /*#__PURE__*/React.createElement(AgentSearch, {
      search: search,
      placeholder: placeholder
    });
  },
  metadata: {
    name: 'constellation/agent-search',
    title: 'Agent Search',
    description: 'Search for agents',
    icon: 'businessperson',
    keywords: ['agent', 'search'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'more',
    attributes: {
      search: {
        type: 'string',
        default: 'zip',
        label: 'Search Type',
        control: 'select',
        choices: [{
          label: 'Zip',
          value: 'zip'
        }, {
          label: 'Installations',
          value: 'installation'
        }]
      },
      placeholder: {
        type: 'string',
        label: 'Placeholder',
        default: 'Enter Zip Code',
        control: 'text'
      }
    }
  }
};

export { AgentSearchBlock as default };
